var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 40.9999573 0 40.9999573 41 0 41"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.2--Cashback-A",
    transform: "translate(-694.000000, -310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(694.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0168067,8.44117647 C20.0654517,8.44117647 19.2941176,9.18358548 19.2941176,10.0992647 L19.2941176,20.0477941 C19.2941176,20.9634733 20.0654517,21.7058824 21.0168067,21.7058824 L29.6302521,21.7058824 C30.5816071,21.7058824 31.3529412,20.9634733 31.3529412,20.0477941 C31.3529412,19.1321149 30.5816071,18.3897059 29.6302521,18.3897059 L22.7394958,18.3897059 L22.7394958,10.0992647 C22.7394958,9.18358548 21.9681618,8.44117647 21.0168067,8.44117647",
    id: "Fill-1",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4999573,41 C31.8219365,41 40.9999573,31.8219792 40.9999573,20.5 C40.9999573,9.17802083 31.8219365,-1.48857994e-15 20.4999573,-1.48857994e-15 L20.4786031,-1.48857994e-15 C14.5921135,-0.00469791667 8.98963437,2.52747917 5.10360312,6.94864583 L5.10360312,3.41666667 C5.10360312,2.47323958 4.33869687,1.70833333 3.39526979,1.70833333 C2.45184271,1.70833333 1.68693646,2.47323958 1.68693646,3.41666667 L1.68693646,11.9583333 C1.68693646,12.9017604 2.45184271,13.6666667 3.39526979,13.6666667 L11.9369365,13.6666667 C12.8803635,13.6666667 13.6452698,12.9017604 13.6452698,11.9583333 C13.6452698,11.0149062 12.8803635,10.25 11.9369365,10.25 L6.83329062,10.25 C12.4942802,2.70215625 23.2021135,1.17234375 30.7499573,6.83333333 C38.297801,12.4943229 39.8276135,23.2021562 34.166624,30.75 C28.5056344,38.2978437 17.797801,39.8276562 10.2499573,34.1666667 C5.94837396,30.9404792 3.41662396,25.8769792 3.41662396,20.5 C3.41662396,19.5565729 2.65171771,18.7916667 1.70829063,18.7916667 C0.764863542,18.7916667 -4.27083333e-05,19.5565729 -4.27083333e-05,20.5 C-4.27083333e-05,31.8219792 9.17797812,41 20.4999573,41",
    id: "Fill-3",
    fill: "#9B9B9B",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.8cf0df12fe7eae5a42e29ad789dad495.svg";
export { ForwardRef as ReactComponent };